<span class="tenant-item d-flex flex-column">
  <span class="tenant-item__name">{{ displayName() }}</span>
  <!-- @if (tenantSlug()) {
    <small class="tenant-item__slug text-muted">{{ tenantSlug() }}</small>
  } -->
</span>
